import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function WaterHeaterSVG({ config = {}, width = 60, height = 85, liveValues = {} }) {
    const running = parseFloat(liveValues.state ?? 1) >= parseFloat(config.threshold ?? 0.5);
    const hasError = liveValues.error === 1 || liveValues.error === true ||
        liveValues.error === '1' || liveValues.error === 'true';
    const statusColor = hasError ? '#EF4444' : running ? '#22C55E' : '#64748B';

    const bodyX = 6;
    const bodyY = 8;
    const bodyW = width - 12;
    const bodyH = height - 20;

    const tempBound = liveValues.temp != null;
    const tempVal = parseFloat(liveValues.temp ?? 0);

    // Heating element color
    const heaterColor = running ? '#F97316' : '#334155';

    // Fill level based on temp (just visual, always full for water heater)
    const fillH = bodyH * 0.7;
    const fillY = bodyY + bodyH - fillH;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Hot water outlet at top */}
            <rect x={bodyX + bodyW / 2 - 3} y={0} width={6} height={bodyY} rx={1} fill="#EF4444" opacity={running ? 0.8 : 0.3} />

            {/* Tank body */}
            <rect x={bodyX} y={bodyY} width={bodyW} height={bodyH} rx={8}
                fill="#0F172A" stroke={statusColor} strokeWidth={2} />

            {/* Water fill */}
            <clipPath id={`whClip_${width}_${height}`}>
                <rect x={bodyX} y={bodyY} width={bodyW} height={bodyH} rx={8} />
            </clipPath>
            <rect x={bodyX} y={fillY} width={bodyW} height={fillH}
                fill="#1D4ED8" opacity={0.35}
                clipPath={`url(#whClip_${width}_${height})`} />

            {/* Error flash */}
            {hasError && (
                <rect x={bodyX} y={bodyY} width={bodyW} height={bodyH} rx={8}
                    fill="none" stroke="#EF4444" strokeWidth={3}>
                    <animate attributeName="stroke-opacity" values="1;0;1" dur="0.6s" repeatCount="indefinite" />
                </rect>
            )}

            {/* Heating element (zigzag) inside tank */}
            {(() => {
                const ex = bodyX + 6;
                const ey = bodyY + bodyH * 0.6;
                const ew = bodyW - 12;
                const seg = ew / 4;
                const amp = 7;
                return (
                    <path
                        d={`M${ex},${ey} l${seg},${-amp} l${seg},${amp} l${seg},${-amp} l${seg},${amp}`}
                        fill="none" stroke={heaterColor} strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round"
                    />
                );
            })()}

            {/* Temp text */}
            {tempBound && (
                <text x={bodyX + bodyW / 2} y={bodyY + bodyH * 0.38}
                    textAnchor="middle" fill="#F1F5F9" fontSize={10} fontWeight="bold">
                    {isNaN(tempVal) ? '--' : tempVal.toFixed(0)}°C
                </text>
            )}

            {/* Status dot */}
            <circle cx={bodyX + bodyW - 7} cy={bodyY + 8} r={4}
                fill={statusColor} stroke="#0F172A" strokeWidth={1} />

            {/* Cold water inlet at bottom */}
            <rect x={bodyX + bodyW / 2 - 3} y={bodyY + bodyH} width={6} height={height - bodyY - bodyH}
                rx={1} fill="#3B82F6" opacity={0.8} />
        </svg>
    );
}

export default function WaterHeaterNode(props) {
    const { data } = props;
    const w = data?.width || 60;
    const h = data?.height || 85;
    return (
        <BaseScadaNode {...props}>
            <WaterHeaterSVG config={data?.config} width={w} height={h} liveValues={data?.liveValues || {}} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', marginTop: 2,
                    overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
